<template>
    <div class="container pt-24 pb-12">
        <a id="main-content" class="fixed top-32" tabindex="-1"></a>

        <h1 class="display mb-4 sm:mb-8 md:mb-12 uppercase">{{ title }}</h1>

        <NewsCategoryTabBar />

        {{/* * */}}
        {{/* * */}}
        {{/* * */}}
        {{/* FEATURED ARTICLES BLOCK ONLY FOR THE "LATEST" ARTICLES CATEGORY */}}
        {{/* * */}}
        <div v-if="!$route.query.category" class="grid grid-cols-12 card-grid-responsive-gap">
            <!-- * -->
            <!-- * -->
            <!-- * -->
            <!-- FEATURED ARTICLE 1 -->
            <!-- * -->
            <article v-if="mostRecentArticles[0]" class="anchor-card col-span-12">
                <NuxtLink
                    :to="
                        localePath({
                            name: 'magazine-article',
                            params: { article: mostRecentArticles[0].slug },
                        })
                    "
                    class="grid grid-cols-12 base-responsive-gap"
                >
                    <div class="col-span-12 md:col-span-6 lg:col-span-7">
                        <div
                            class="thumbnail base-responsive-rounding aspect-w-1 aspect-h-1 sm:aspect-w-3 sm:aspect-h-2"
                        >
                            <img
                                :src="
                                    $getMediaImage(mostRecentArticles[0].media, 'lead', 'md', ['square', 'landscape'])
                                "
                                :alt="mostRecentArticles[0].title"
                            />
                        </div>
                    </div>

                    <div class="col-span-12 md:col-span-6 lg:col-span-5">
                        <div class="flex items-center auxiliary-text uppercase mb-4">
                            <time :datetime="mostRecentArticles[0].date">
                                {{ $dayjs(mostRecentArticles[0].date).format('YYYY/MM/DD') }}
                            </time>
                            <span class="inline">
                                <span class="separator-bullet"></span>
                                {{ $getNewsCategoryLabel(mostRecentArticles[0].category_id) }}
                            </span>
                        </div>

                        <div>
                            <div class="header-3 mb-5">{{ mostRecentArticles[0].title }}</div>
                            <div class="mb-3" v-html="mostRecentArticles[0].lead_text"></div>
                            <Button
                                :label="$t('news.read_more_button_label')"
                                class="p-button-secondary p-button-text -translate-x-2"
                                icon="pi pi-chevron-right"
                            />
                        </div>
                    </div>
                </NuxtLink>
            </article>

            <!-- * -->
            <!-- * -->
            <!-- * -->
            <!-- FEATURED ARTICLE 2 -->
            <!-- * -->
            <article v-if="mostRecentArticles[1]" class="anchor-card col-span-12 lg:col-span-6">
                <NuxtLink
                    :to="
                        localePath({
                            name: 'magazine-article',
                            params: { article: mostRecentArticles[1].slug },
                        })
                    "
                    class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 md:gap-4"
                >
                    <div>
                        <div class="thumbnail base-responsive-rounding aspect-w-3 aspect-h-2">
                            <img
                                :src="$getMediaImage(mostRecentArticles[1].media, 'lead')"
                                :alt="mostRecentArticles[1].title"
                            />
                        </div>
                    </div>

                    <div>
                        <div class="flex items-center auxiliary-text uppercase mb-4 mt-4">
                            <time :datetime="mostRecentArticles[1].date">
                                {{ $dayjs(mostRecentArticles[1].date).format('YYYY/MM/DD') }}
                            </time>
                            <span class="inline">
                                <span class="separator-bullet"></span>
                                {{ $getNewsCategoryLabel(mostRecentArticles[1].category_id) }}
                            </span>
                        </div>

                        <div class="header-3 mb-5">{{ mostRecentArticles[1].title }}</div>
                        <div class="mb-3" v-html="mostRecentArticles[1].lead_text"></div>
                        <Button
                            :label="$t('news.read_more_button_label')"
                            class="p-button-secondary p-button-text -translate-x-2"
                            icon="pi pi-chevron-right"
                        />
                    </div>
                </NuxtLink>
            </article>

            <!-- * -->
            <!-- * -->
            <!-- * -->
            <!-- FEATURED ARTICLE 3 -->
            <!-- * -->
            <article v-if="mostRecentArticles[2]" class="anchor-card col-span-12 lg:col-span-6 lg:pt-16">
                <NuxtLink
                    :to="
                        localePath({
                            name: 'magazine-article',
                            params: { article: mostRecentArticles[2].slug },
                        })
                    "
                    class="grid grid-cols-1 md:grid-cols-2 base-responsive-gap"
                >
                    <div>
                        <div
                            class="thumbnail base-responsive-rounding aspect-w-3 aspect-h-2 lg:aspect-w-3 lg:aspect-h-4"
                        >
                            <img
                                :src="
                                    $getMediaImage(mostRecentArticles[2].media, 'lead', 'sm', ['portrait', 'landscape'])
                                "
                                :alt="mostRecentArticles[2].title"
                            />
                        </div>
                    </div>

                    <div>
                        <div class="flex items-center auxiliary-text uppercase mb-4">
                            <time :datetime="mostRecentArticles[2].date">
                                {{ $dayjs(mostRecentArticles[2].date).format('YYYY/MM/DD') }}
                            </time>
                            <span class="inline">
                                <span class="separator-bullet"></span>
                                {{ $getNewsCategoryLabel(mostRecentArticles[2].category_id) }}
                            </span>
                        </div>

                        <div class="font-Poppins text-xl font-semibold mb-5">{{ mostRecentArticles[2].title }}</div>
                        <div class="mb-3" v-html="mostRecentArticles[2].lead_text"></div>
                        <Button
                            :label="$t('news.read_more_button_label')"
                            class="p-button-secondary p-button-text -translate-x-2"
                            icon="pi pi-chevron-right"
                        />
                    </div>
                </NuxtLink>
            </article>
        </div>

        <div
            v-else-if="mostRecentArticles.length"
            :key="`featured-${$route.query.category}`"
            class="grid grid-cols-12 base-responsive-gap"
        >
            {{/* * */}}
            {{/* * */}}
            {{/* * */}}
            {{/* FEATURED ARTICLES BLOCK FOR OTHER CATEGORIES */}}
            {{/* * */}}
            <div
                v-if="mostRecentArticles.length"
                class="col-span-12 xl:col-span-10 xl:col-start-2 grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-12 lg:gap-x-7 lg:gap-y-10"
            >
                <article v-for="article in mostRecentArticles" :key="article.slug" class="anchor-card">
                    <NuxtLink
                        :to="
                            localePath({
                                name: 'magazine-article',
                                params: { category: article.category, article: article.slug },
                            })
                        "
                        class="grid grid-cols-1 lg:grid-cols-2md:gap-4"
                    >
                        <div>
                            <div class="thumbnail base-responsive-rounding aspect-w-3 aspect-h-2">
                                <img :src="$getMediaImage(article.media, 'lead')" :alt="article.title" />
                            </div>
                        </div>

                        <div>
                            <div class="flex items-center auxiliary-text uppercase mb-4 mt-4">
                                <time :datetime="article.date">
                                    {{ $dayjs(article.date).format('YYYY/MM/DD') }}
                                </time>
                                <span v-if="article.category_id" class="inline">
                                    <span class="separator-bullet"></span>
                                    {{ $getNewsCategoryLabel(article.category_id) }}
                                </span>
                            </div>

                            <div class="header-3">{{ article.title }}</div>
                        </div>
                    </NuxtLink>
                </article>
            </div>
        </div>

        {{/* * */}}
        {{/* * */}}
        {{/* * */}}
        {{/* LIST OF NON-FEATURED ARTICLES */}}
        {{/* * */}}
        <div
            v-if="articles.length"
            :key="`list-${category?.id || 'any'}`"
            class="grid grid-cols-12 base-responsive-gap mt-12 lg:mt-20"
        >
            <div class="col-span-12 xl:col-span-10 xl:col-start-2">
                <div class="grid grid-cols-12 card-grid-responsive-gap xl:gap-y-14">
                    <div
                        v-for="article in articles"
                        :key="article.slug"
                        class="col-span-12 sm:col-span-6 lg:col-span-4"
                    >
                        <ArticleCard
                            :date="article.published_at"
                            :img="$getMediaImage(article.media, 'lead', 'sm')"
                            :slug="article.slug"
                            :tag="$getNewsCategoryLabel(article.category_id)"
                            :title="article.title"
                            flex-row-on-mobile
                        />
                    </div>
                </div>
            </div>
            <div class="col-span-12 text-center mt-12 sm:mt-16 lg:mt-20 xl:mt-24">
                <Button
                    v-if="(!$route.query.page && pagesCount > 1) || +$route.query.page < pagesCount"
                    :label="$t('news.load_more_articles_button_label')"
                    @click.native="loadMore"
                />
                <Button v-else :label="$t('news.archive.title')" :to="localePath({ name: 'archive' })" />
            </div>
        </div>

        <div v-if="!mostRecentArticles.length && !articles.length" class="md-lead mt-12">
            <T t="news.no_articles_text" />
        </div>
    </div>
</template>

<script>
import NewsCategoryTabBar from '@/components/Navigation/NewsCategoryTabBar/NewsCategoryTabBar.vue';
import ArticleCard from '@/components/Cards/ArticleCard/ArticleCard.vue';

export default {
    name: 'NewsIndex',
    components: {
        ArticleCard,
        NewsCategoryTabBar,
    },
    layout: 'theme-dark',
    async asyncData({ $axios, query, redirect, store, i18n, localePath }) {
        // // if the page query is invalid, instead of 404 we redirect to /magazine
        if (query.page && isNaN(+query.page)) {
            return await redirect(307, localePath({ name: 'magazine' }));
        }

        // selected category
        const category = store.state.data.newsCategories.find((x) => x.slug === query.category);

        // // if there is a category slug in the url as a query param but is invalid, we also redirect to /magazine
        if (query.category && !category) {
            return await redirect(307, localePath({ name: 'magazine' }));
        }

        // pagination mechanism copied from The New York Times
        const ITEMS_PER_PAGE = 12;

        // Set default category name & id
        let title = i18n.t('navigation.news');

        const page = query.page ? +query.page : 1;

        // featured articles will contain the first 3 articles
        let mostRecentArticles = [];
        // articles will contain every article except the first 3
        let articles = [];

        let _notFoundByPage = false;
        let articlesCount = null;
        let pagesCount = null;
        let _newsEndpoint = '/news';
        const _offset = query.page ? (+query.page - 1) * ITEMS_PER_PAGE : '';

        const _selectedArticleCategoryQuery = category ? '&category_id=' + category.id : '';
        _newsEndpoint += `?${_selectedArticleCategoryQuery}`;

        // add stuff needed for pagination
        _newsEndpoint += `&limit=${ITEMS_PER_PAGE * page + (page === 1 && category ? 1 : 0)}`;

        await $axios
            .$get(_newsEndpoint)
            .then((res) => {
                if (_offset > res.total) {
                    _notFoundByPage = true;
                }

                mostRecentArticles = res.data.slice(0, category ? 4 : 3);
                articles = res.data.slice(category ? 4 : 3);

                articlesCount = res.total;
                pagesCount = Math.ceil(res.total / ITEMS_PER_PAGE);
            })
            .catch((err) => {
                console.log(err);
            });

        if (_notFoundByPage) {
            return await redirect(307, localePath({ name: 'magazine' }));
        }

        if (category) {
            title = category.name;
        }

        return {
            title,
            page,
            mostRecentArticles,
            articles,
            articlesCount,
            pagesCount,
            category,
            ITEMS_PER_PAGE,
        };
    },
    head() {
        return {
            title: this.$getPageTitle('news.index'),
            meta: this.$getPageMetaData('news.index'),
        };
    },
    watchQuery: ['category'],
    methods: {
        async loadMore() {
            let _newsEndpoint = '/news';

            const currentPage = this.$route.query.page ? +this.$route.query.page : 1;

            let _offset = currentPage * this.ITEMS_PER_PAGE;

            const category = this.$store.state.data.newsCategories.find((x) => x.slug === this.$route.query.category);

            if (category) {
                _offset += 1;
            }

            const _selectedArticleCategoryQuery = category ? 'category_id=' + category.id : 'category_id=';

            // add stuff needed for pagination
            _newsEndpoint += `?${_selectedArticleCategoryQuery}&limit=${this.ITEMS_PER_PAGE}&offset=${_offset}`;

            await this.$router.replace(
                this.localePath({ name: 'magazine', query: { ...this.$route.query, page: currentPage + 1 } })
            );

            await this.$axios
                .$get(_newsEndpoint)
                .then((res) => {
                    this.articles = [...this.articles, ...res.data];
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
};
</script>

<style scoped></style>
